const PRIVACY_POLICY_ZH = `隐私政策

生效日期：2026年8月25日
最后更新日期：2026年8月25日
欢迎访问 ANOVATOR 官方网站。
源诺医疗及其关联公司（以下简称“ANOVATOR”“我们”或“本公司”）非常重视您的个人信息和隐私保护。
本隐私政策用于说明，当您访问或使用 ANOVATOR 官方网站（以下简称“本网站”）以及通过本网站提供的相关服务时，我们如何收集、使用、存储、保护和处理您的个人信息，以及您如何行使相关个人信息权利。
请您在使用本网站前仔细阅读并理解本隐私政策。

一、我们是谁

本网站由

公司名称：武汉宅客网络科技有限公司
品牌名称：ANOVATOR / 源诺医疗
注册地址：湖北省武汉市江夏区藏龙岛开发区杨桥湖大道27号中电信息港B2栋7楼
联系邮箱：info@anovator.com
个人信息保护联系方式：emma@anovator.com

负责运营。

如您对本隐私政策或个人信息处理存在任何疑问，可以通过上述联系方式与我们联系。

二、我们如何收集个人信息

根据您使用本网站的具体方式，我们可能收集以下类型的信息。

1. 您主动提供的信息

当您通过本网站进行产品咨询、联系我们、申请经销商合作、展会报名或提交其他信息时，我们可能收集：
姓名；
公司名称；
职位；
国家或地区；
电子邮箱；
电话号码；
公司地址或联系地址；
您主动填写的咨询内容；
与产品采购、合作或服务相关的信息。
我们仅在实现相应业务目的所必要的范围内收集个人信息。

2. 网站访问过程中自动收集的信息

当您访问本网站时，我们可能自动收集与网站运行和安全相关的信息，包括：
IP地址；
浏览器类型及版本；
操作系统；
设备类型；
语言设置；
访问时间；
访问页面；
页面停留时间；
来源页面；
网站操作及交互信息；
Cookie 及类似技术产生的信息。
上述信息可能在特定情况下构成个人信息。

3. 您主动提交的其他信息

如果您在产品咨询、商务合作、反馈或其他互动过程中主动向我们提供其他信息，我们可能根据具体业务目的处理相关信息。
请勿通过普通网站表单提交您的身份证件、医疗记录、疾病信息、体检报告或其他敏感个人信息，除非我们明确提供了相应的安全处理渠道并另行向您说明。

三、我们为什么处理您的个人信息

我们可能基于以下目的处理您的个人信息：

1. 网站正常运行

用于：
提供网站基本功能；
确保网站稳定运行；
维护网站及信息系统安全；
保存您的语言、地区及隐私偏好；
防止恶意访问及网络攻击。

2. 产品及服务咨询

当您主动联系我们时，我们可能使用您提供的信息：
回复您的咨询；
提供产品信息；
提供产品资料；
进行商务沟通；
处理售前咨询。

3. 经销商及商务合作

如果您提交经销商、代理商或其他合作申请，我们可能使用您提供的信息：
评估合作需求；
与您取得联系；
提供产品及合作资料；
处理合作申请。

4. 展会及活动

如果您报名参加 ANOVATOR 参与或组织的展会、会议或其他活动，我们可能使用您提供的信息：
完成报名；
确认参会身份；
发送活动通知；
提供展会相关信息；
进行活动后的商务沟通。

5. 网站分析及体验优化

在适用法律要求并取得必要同意的情况下，我们可能使用 Cookie 或类似技术分析网站访问情况，例如：
访问量；
页面访问情况；
用户来源；
网站性能；
用户与页面的交互情况。
相关信息主要用于优化网站内容、功能和用户体验。

6. 法律及安全目的

我们可能在法律法规允许或要求的范围内处理相关信息，用于：
维护网络和信息安全；
防止欺诈及恶意行为；
处理安全事件；
保护我们及其他用户的合法权益；
履行法律法规规定的义务。

四、Cookie 及类似技术

本网站可能使用 Cookie、Local Storage、像素标签及其他类似技术。
我们可能使用这些技术：

保障网站正常运行；
保存您的偏好；
记录您的隐私设置；
分析网站访问情况；
改善网站性能及用户体验。

对于需要取得用户同意的非必要 Cookie，我们将在取得您的同意后使用。
您可以通过网站中的：

“隐私设置 / Privacy Preferences”
管理或修改相关 Cookie 选择。
如您希望了解更多 Cookie 信息，可以通过本网站的隐私设置查看相关类别及用途。

五、我们如何使用和保护您的个人信息

我们会根据实际业务需要采取合理的安全措施保护您的个人信息，包括但不限于：

建立个人信息安全管理制度；
对个人信息进行分类管理；
实施访问权限控制；
对相关人员设置必要的访问权限；
采取加密、去标识化等合理技术措施；
对相关人员进行安全和隐私保护培训；
建立个人信息安全事件应急机制。

我们会根据技术发展、业务变化和风险情况持续完善安全措施。
根据《个人信息保护法》，个人信息处理者应当采取相应的技术和管理措施，防止未经授权访问以及个人信息泄露、篡改或丢失。

六、我们如何共享您的个人信息

我们不会出售您的个人信息。
在提供网站服务、处理您的请求或开展必要业务的情况下，我们可能向以下类别的服务提供商提供必要的信息：

网站及服务器托管服务商；
云服务提供商；
网站分析服务商；
邮件服务商；
CRM 或客户管理服务商；
表单服务商；
网络安全服务商；
技术及运维服务商。

我们会要求相关受托方按照约定的目的、方式和范围处理个人信息，并采取相应的安全保护措施。
除非法律法规另有规定，我们不会将您的个人信息用于与收集目的无关的其他用途。

七、向其他个人信息处理者提供个人信息

如果因业务需要，我们需要向其他独立的个人信息处理者提供您的个人信息，我们将根据适用法律法规履行相应的告知和同意义务。
在法律要求取得单独同意的情况下，我们将依法取得您的单独同意。

八、个人信息保存期限

我们仅在实现处理目的所必要的最短期限内保存您的个人信息。
保存期限可能根据以下因素确定：

信息处理目的；
业务关系持续时间；
您与我们的沟通情况；
法律法规要求；
争议解决需要；
网络安全及审计要求。

当相关个人信息达到保存期限后，我们将按照适用法律法规删除、匿名化或采取其他适当方式处理。
《个人信息保护法》原则上要求个人信息保存期限为实现处理目的所必要的最短时间。

九、您的个人信息权利

在适用法律法规规定的范围内，您可以依法行使以下权利：

查询、复制您的个人信息；
请求更正或补充您的个人信息；
请求删除您的个人信息；
请求限制或拒绝处理您的个人信息；
撤回已经作出的同意；
注销相关账户或服务（如适用）；
对个人信息处理提出异议；
依法享有的其他个人信息权利。

您可以通过以下方式联系我们：

个人信息保护邮箱：emma@anovator.com
我们将在收到您的请求后，根据适用法律法规进行处理。
为了保护您的个人信息安全，我们可能在处理请求前对您的身份进行必要验证。

十、如何撤回您的同意

如果我们基于您的同意处理个人信息，您可以撤回相关同意。
对于 Cookie，您可以通过：
隐私设置 / Privacy Preferences
修改相关 Cookie 选择。
对于其他个人信息处理活动，您可以通过联系：
emma@anovator.com
申请撤回相关同意。
撤回同意不会影响撤回前基于您同意已经进行的个人信息处理活动的合法性。

十一、敏感个人信息及医疗健康信息

ANOVATOR 是人体测量及健康评估设备品牌。
本网站主要用于展示公司、产品、技术及服务信息，一般情况下不会要求您通过普通网站页面提交医疗健康信息。
根据《个人信息保护法》，医疗健康信息属于敏感个人信息。处理敏感个人信息应当具有特定目的和充分必要性，并采取严格保护措施；在基于同意处理的情况下，还应依法取得个人单独同意，并告知处理的必要性以及对个人权益的影响。

因此：
请不要通过普通“联系我们”“产品咨询”或“经销商申请”等表单主动提交以下信息：

疾病信息；
病史；
医疗诊断信息；
医疗检查报告；
体检报告；
血压、血氧等健康数据；
人体成分数据；
其他医疗健康信息。

如果未来 ANOVATOR 在官网提供在线体测、健康评估、健康报告上传、AI 健康服务或其他涉及医疗健康数据的功能，我们将根据具体业务场景另行向您说明相关处理目的、处理方式、信息类别、保存期限、必要性及对个人权益的影响，并依法履行相应的个人信息保护义务。

十二、未成年人个人信息保护

本网站主要面向成年人、医疗机构、医疗专业人员、企业、经销商及其他专业用户。
如果您未满18周岁，建议您在父母或其他监护人的指导下使用本网站。
对于不满14周岁未成年人的个人信息，我们将按照适用法律法规采取更加严格的保护措施。
如果您发现未成年人在未经适当授权的情况下向我们提供了个人信息，请通过本政策所列联系方式与我们联系。

十三、第三方网站及服务

本网站可能包含指向第三方网站、平台或服务的链接，例如：

视频平台；
社交媒体平台；
地图服务；
第三方内容平台；
其他合作伙伴网站。

当您访问或使用这些第三方服务时，相关个人信息处理活动可能由第三方独立负责。
第三方服务适用其自身的隐私政策及相关规则。
我们建议您在使用第三方服务前阅读其相关隐私政策。

十四、个人信息跨境处理

ANOVATOR 面向全球市场开展业务。
如果因网站运营、技术服务、客户服务或其他业务需要涉及向中华人民共和国境外提供个人信息，我们将根据适用法律法规履行相应的个人信息出境合规义务。
如果相关处理依法需要向您告知接收方、处理目的、处理方式、个人信息种类等信息，我们将依法进行告知，并在法律要求的情况下取得相应同意。

十五、个人信息安全事件

如果发生或可能发生个人信息泄露、篡改、丢失等安全事件，我们将根据适用法律法规采取相应的补救措施，并在法律规定的情况下向有关主管部门及相关个人进行通知。

十六、隐私政策的更新

我们可能根据：

网站功能变化；
业务模式变化；
第三方服务变化；
技术发展；
法律法规变化；

对本隐私政策进行更新。
更新后的隐私政策将在本网站公布。
如涉及个人信息处理目的、处理方式或个人信息种类发生重大变化，我们将按照适用法律法规履行相应的告知及同意义务。
最后更新时间：2026年8月25日

十七、联系我们

如果您对本隐私政策、个人信息处理或个人信息权利行使有任何疑问，可以通过以下方式联系我们：
公司名称：武汉宅客网络科技有限公司
品牌名称：ANOVATOR / 源诺医疗
注册地址：湖北省武汉市江夏区藏龙岛开发区杨桥湖大道27号中电信息港B2栋7楼
联系邮箱：info@anovator.com
个人信息保护邮箱：emma@anovator.com
我们将在收到您的请求后，根据适用法律法规及时进行处理。`

module.exports = { PRIVACY_POLICY_ZH }
